module.exports = __webpack_public_path__ + "images/chevron.49062488fac145ed289e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/chevron.png
// module id = Wvgl
// module chunks = 24